<div class="modal-header">
    <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close" (click)="cancel()"><span aria-hidden="true">&times;</span></button>
    <h4 class="modal-title" id="labelButtons">Confirm Disbursement</h4>
</div>

<div class="modal-body">
    <p>A check for <b>{{requestedAmount.toFixed(2) | dollar}}</b> will be mailed to {{displayName}}.</p>

    <table class="mvd_table--table">
        <tr>
            <td><b>Current Balance:</b> &nbsp; </td>
            <td>{{currentBalance.toFixed(2) | dollar}}</td>
        </tr>
        <tr>
            <td><b>Disbursement Amount:</b> &nbsp; </td>
            <td>{{requestedAmount.toFixed(2) | dollar}}</td>
        </tr>
        <tr>
            <td><b>New Account Balance:</b> &nbsp; </td>
            <td>{{newAccountBalance.toFixed(2) | dollar}}</td>
        </tr>
    </table>
</div>

<div class="modal-footer">
    <div class="btn--group">
        <button class="btn--default" type="button" data-bs-dismiss="modal" (click)="cancel()">Cancel</button>
        <button class="btn--primary" type="button" (click)="submit()">Submit</button>
    </div>
</div>